import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background"></div>
        <div className="container">
          <div className="hero-content fade-in">
            <h1>
              Transforming Ideas Into
              <span className="gradient-text"> Digital Solutions</span>
            </h1>
            <p className="hero-subtitle">
              With over 15 years of expertise in software development and IT consultancy, 
              we deliver cutting-edge business applications and technology solutions.
            </p>
            <div className="hero-buttons">
              <Link to="/services" className="btn btn-primary">
                Explore Services
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Get in Touch
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <h3 className="stat-number">15+</h3>
              <p className="stat-label">Years Experience</p>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">200+</h3>
              <p className="stat-label">Projects Delivered</p>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">50+</h3>
              <p className="stat-label">Happy Clients</p>
            </div>
            <div className="stat-card">
              <h3 className="stat-number">24/7</h3>
              <p className="stat-label">Support Available</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section section-light">
        <div className="container">
          <div className="section-title">
            <h2>Our Core Services</h2>
            <p>Comprehensive IT solutions tailored to your business needs</p>
          </div>

          <div className="grid grid-3">
            <div className="service-card card">
              <div className="service-icon">💻</div>
              <h3>Software Development</h3>
              <p>
                Custom web and mobile applications built with modern technologies. 
                From enterprise solutions to scalable business applications.
              </p>
              <Link to="/services#software" className="service-link">
                Learn More →
              </Link>
            </div>

            <div className="service-card card">
              <div className="service-icon">🎯</div>
              <h3>Consultancy Services</h3>
              <p>
                Expert guidance in application development, legacy system migration, 
                and business analysis to optimize your technology stack.
              </p>
              <Link to="/services#consultancy" className="service-link">
                Learn More →
              </Link>
            </div>

            <div className="service-card card">
              <div className="service-icon">🖥️</div>
              <h3>IT Equipment Procurement</h3>
              <p>
                Professional sourcing and procurement of quality IT equipment 
                and infrastructure for your business needs.
              </p>
              <Link to="/services#procurement" className="service-link">
                Learn More →
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Tech Stack Section */}
      <section className="section tech-stack-section">
        <div className="container">
          <div className="section-title">
            <h2>Our Technology Stack</h2>
            <p>Leveraging modern tools and frameworks to build robust solutions</p>
          </div>

          <div className="tech-categories">
            <div className="tech-category">
              <h4>Backend</h4>
              <div className="tech-tags">
                <span className="tech-tag">Python / Flask</span>
                <span className="tech-tag">FastAPI</span>
                <span className="tech-tag">PHP / Laravel</span>
                <span className="tech-tag">CakePHP</span>
                <span className="tech-tag">Yii2</span>
              </div>
            </div>

            <div className="tech-category">
              <h4>Frontend</h4>
              <div className="tech-tags">
                <span className="tech-tag">React</span>
                <span className="tech-tag">JavaScript</span>
                <span className="tech-tag">HTML5</span>
                <span className="tech-tag">CSS3</span>
                <span className="tech-tag">Ajax</span>
              </div>
            </div>

            <div className="tech-category">
              <h4>Databases</h4>
              <div className="tech-tags">
                <span className="tech-tag">MySQL</span>
                <span className="tech-tag">PostgreSQL</span>
                <span className="tech-tag">MariaDB</span>
                <span className="tech-tag">MongoDB</span>
              </div>
            </div>

            <div className="tech-category">
              <h4>DevOps & Tools</h4>
              <div className="tech-tags">
                <span className="tech-tag">Docker</span>
                <span className="tech-tag">Kubernetes</span>
                <span className="tech-tag">Jenkins</span>
                <span className="tech-tag">Git</span>
                <span className="tech-tag">Swagger</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section section-dark cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Project?</h2>
            <p>
              Let's discuss how we can help transform your business with innovative technology solutions.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Get Started Today
            </Link>
          </div>
        </div>
      </section>

      {/* Portfolio Preview Section */}
      <section className="section section-light portfolio-preview">
        <div className="container">
          <div className="section-title">
            <h2>Our Applications</h2>
            <p>Explore our portfolio of innovative in-house applications</p>
          </div>

          <div className="grid grid-3">
            <div className="preview-card card">
              <div className="preview-icon">⚡</div>
              <h3>Utilities Notifier</h3>
              <p>Real-time service interruption alerts</p>
            </div>

            <div className="preview-card card">
              <div className="preview-icon">💰</div>
              <h3>Ezemali</h3>
              <p>Financial management platform</p>
            </div>

            <div className="preview-card card">
              <div className="preview-icon">🏇</div>
              <h3>Kumkani Mhlontlo Festival</h3>
              <p>Horse racing event platform</p>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/portfolio" className="btn btn-primary">
              View All Applications →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
